import { HumanFemaleFemaleIcon } from './HumanFemaleFemaleIcon';

/**
 * author: Henrique César Madeira
 * id 63BC56A3-B593-4789-BEAE-2696E6DC2CB6
 * name human-female-female
 * version: 2.6.95
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/human-female-female.svg
 * tags
 * - People / Family 
 */
export const WomenIcon = HumanFemaleFemaleIcon;
export default WomenIcon